import ActivitiesList from '@src/pages/Activities/ActivitiesList.tsx'
import { ActivitiesShowProvider } from '@logic/contexts/Activities/ActivitiesShowContext.tsx'
import ActivitiesShow from '@src/pages/Activities/Show/ActivitiesShow.tsx'
import { LearnerListProvider } from '@logic/contexts/Learners/LearnersListContext.tsx'

export default {
  list: <LearnerListProvider filter={null}><ActivitiesList /></LearnerListProvider>,
  show: <ActivitiesShowProvider><ActivitiesShow /></ActivitiesShowProvider>,
}
